import { AlertTriangleIcon, Loader2Icon } from 'lucide-react'
import { memo, type ReactNode } from 'react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface BillingPaymentMethodWarningProps {
  onAddPaymentMethod: () => void
  isLoading?: boolean
  className?: string
}

const BillingPaymentMethodWarningBase: React.FC<BillingPaymentMethodWarningProps> = ({
  onAddPaymentMethod,
  isLoading = false,
  className,
}): ReactNode => (
  <Alert
    className={cn(
      'billing-payment-method-warning border-yellow-500/50 bg-yellow-50 text-yellow-900 dark:bg-yellow-950 dark:text-yellow-100',
      className
    )}
  >
    <AlertTriangleIcon className="text-yellow-600 dark:text-yellow-400" />
    <AlertTitle>Payment method required</AlertTitle>
    <AlertDescription className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <span className="text-yellow-800 dark:text-yellow-200">
        You don&apos;t have a payment method added. Please add one to enable top-ups.
      </span>
      <Button
        variant="outline"
        size="sm"
        onClick={onAddPaymentMethod}
        disabled={isLoading}
        className="billing-payment-method-warning-link w-fit border-yellow-600/50 text-yellow-900 hover:bg-yellow-100 dark:border-yellow-400/50 dark:text-yellow-100 dark:hover:bg-yellow-900"
      >
        {isLoading ? (
          <>
            <Loader2Icon className="mr-2 size-4 animate-spin" />
            Redirecting...
          </>
        ) : (
          'Add payment method'
        )}
      </Button>
    </AlertDescription>
  </Alert>
)

export const BillingPaymentMethodWarning = memo(BillingPaymentMethodWarningBase)

BillingPaymentMethodWarning.displayName = 'BillingPaymentMethodWarning'
